const ADD_BUTTON = 'add';
const ICON_BROWSE = 'icon-browse';
const ICON_SEARCH = 'icon-search';
const NO_ICON_SEARCH = 'no-icon-search';
export { ADD_BUTTON, ICON_BROWSE, ICON_SEARCH, NO_ICON_SEARCH };
